import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class FreespinsTriggered extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        let triggered = false;

        if (record instanceof SpinRecord) {
            triggered = record.freespinsTriggered;
        }

        if (record.beenPaid) {
            triggered = false;
        }

        return triggered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/freespins-triggered.ts